/**
 * PDF Viewer Component Types
 * Migrated from lego/page/browser/doc-preview/PdfViewer.jsx
 */

export const CHECK_INTERVAL = 1000

export const CONVERSION_STATUS = {
  CONVERTED_OK: 'CONVERTED_OK',
  CONVERTING: 'CONVERTING',
  FAILED: 'FAILED'
} as const

export type ConversionStatus = (typeof CONVERSION_STATUS)[keyof typeof CONVERSION_STATUS]

export const EVENTS = {
  LOADING: 'LOADING',
  LOADING_FILE: 'LOADING_FILE',
  SUCCESS_LOADING: 'SUCCESS_LOADING',
  ERROR_LOADING: 'ERROR_LOADING',
  DONE_RENDERING_FILE: 'DONE_RENDERING_FILE',
  LAST_PAGE: 'LAST_PAGE',
  BEFORE_PRINT: 'BEFORE_PRINT',
  AFTER_PRINT: 'AFTER_PRINT',
  OCR_TOGGLE_STATE_CHANGE: 'OCR_TOGGLE_STATE_CHANGE',
  VIEWED_IN_BROWSER_TAB: 'VIEWED_IN_BROWSER_TAB'
} as const

export type PdfViewerEvent = (typeof EVENTS)[keyof typeof EVENTS]

export interface PdfViewerSource {
  service?: () => Promise<any>
  request?: Promise<any>
  callback?: (url: string) => void
}

export interface PdfViewerFile {
  id: number
  versionId: string
  workflowId?: string
  canShowOcrPdf?: boolean
}

export interface PdfViewerPrintLog {
  fsiId: number
}

export interface PdfViewerProps {
  src?: PdfViewerSource | string // Can be object with service/request OR direct URL string
  downloadFunction?: () => void
  hasDownloaded?: boolean
  thumbnailId?: string
  file?: PdfViewerFile
  disablePrint?: boolean
  printLog?: PdfViewerPrintLog
  onLastPage?: () => void
  className?: string
}

export interface PdfViewerState {
  src: PdfViewerSource | null
  downloadFunction?: () => void
  hasDownloaded?: boolean
  thumbnailId?: string
  disableFontFaceParam: string
  localeParam: string
  viewerUrl: string
  url: string | null
  iframeUrl: string | null
  iframeUrlCurrent: string | null
  useNative: boolean
  frameHeight: number
  isInstantiated: boolean
  request1: Promise<any> | null
  service2: (() => Promise<any>) | null
  request2: Promise<any> | null
  hasFailed: boolean
  ocrFileUrl: string | null
  orignalIframeUrl: string | null
  orignalUrl: string | null
  showOverlay?: boolean
  showLoader?: boolean
  showDownload?: boolean
  showMessage?: boolean
  loaderStatus?: string | null
  statusParams?: Record<string, any> | null
  backgroundImage?: string
}

export interface PdfViewerMessageEvent extends MessageEvent {
  data: {
    pdfViewer: PdfViewerEvent
    pdfUrl: string
    isChecked?: boolean
  }
}

export interface ConversionStatusResponse {
  conversionState: ConversionStatus
  url?: string
  s3Url?: string
  message?: string
  uuidToCheckState?: string
}
